import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DescriptionIcon from '@mui/icons-material/Description';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import TocIcon from '@mui/icons-material/Toc';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useState } from 'react';
import DisplayFinancialProtection from '../settings/financialProtection/DisplayFinancialProtection';
import DisplayMemberBank from '../settings/memberBankDetails/DisplayMemberBank';
import MyInvoice from './invoiceList/MyInvoice';
import OwedInvoice from './invoiceList/OwedInvoice';




interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  index: string;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};


const InvoiceList = ({ setFlag, updateRecord }) => {
  const [value, setValue] = useState<string>('0');
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };


  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Tabs className='tab-list mb-2' value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab icon={<DescriptionIcon />} value="0" label="Inward Invoice" iconPosition='start' />
          <Tab icon={<MonetizationOnIcon />} value="1" label="Outward Invoice" iconPosition='start'/>
          <Tab icon={< AccountBalanceIcon />} value="2" label="Bank Details" iconPosition='start'/>
          <Tab icon={<TocIcon />} value="3" label="Guidelines" iconPosition='start'/>
        </Tabs>
      </Box>

      <TabPanel value={value} index="0">
        <OwedInvoice 
          setFlag={setFlag}
          updateRecord={updateRecord}
        />
      </TabPanel>

      <TabPanel value={value} index="1">
        <MyInvoice
          setFlag={setFlag}
          updateRecord={updateRecord}
        />
      </TabPanel>
      <TabPanel value={value} index="2">
        <DisplayMemberBank />
      </TabPanel>
      <TabPanel value={value} index="3">
        <DisplayFinancialProtection />
      </TabPanel>
    </>
  );
};

export default InvoiceList;
